export default {
  // cognito settings
  COGN_USERPOOL_ID: 'ap-southeast-1_Hovj4kl8O',
  COGN_CLIENT_ID: '1jbh58j4qhoea4qgotfgf0mgen',
  COGN_TOKEN_SCOPE: ['openid', 'email', 'profile'],
  COGN_APP_DOMAIN: '1ed-tester-sys.auth.ap-southeast-1.amazoncognito.com',
  COGN_CALLBACK_URL: 'https://test.1ed.hk/login/oauth2/code/cognito',
  CONG_SIGNOUT_URL: 'https://test.1ed.hk/logout',

  // backend settings
  BACKEND_API_URL:
    'https://50bnfy5qub.execute-api.ap-southeast-1.amazonaws.com/dev/graphql',

  // local urls
  LOGIN_REDIRECT_URL: '/home', // the redirect url after login successfully
  TESTER_DEFAULT_PATH: '/tester/home',
  ADMIN_DEFAULT_PATH: '/admin/tester'
}
